import { render, staticRenderFns } from "./SignRequestTemplateModal.vue?vue&type=template&id=56596acc&scoped=true&"
import script from "./SignRequestTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SignRequestTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./SignRequestTemplateModal.vue?vue&type=style&index=0&id=56596acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56596acc",
  null
  
)

export default component.exports